/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import useSWR from 'swr';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { usePerformanceMark, Stage } from '@cabify/prom-react';

import Button from '../../../../Common/Components/Button';
import Table from '../../../../Common/Components/Table';
import { PageComponentProps } from '../../../../types/PageComponentProps';
import { FixtureObject } from '../../../../types/FixtureObject';
import useFixturesPageState from '../../../../utils/state/useFixturesPageState';
import { getRequest } from '../../../../utils/fetch';
import AdminSidebarConfigItems from '../../Components/AdminSidebarConfigItems';
import AdminSidebar from '../../../../Common/Components/AdminSidebar';
import CreateEditFixture from './Components/CreateEditFixture';

import ViewFixture from './Components/ViewFixture';
import Tooltip from '../../../../Common/Components/Tooltip';

import { ReactComponent as EditIcon } from '../../../../img/icons/edit.svg';
import { ReactComponent as WarningIcon } from '../../../../img/icons/orangewarning.svg';

import Utils from '../../../../utils/Utils';
import TableToolbar from '../../../Admin/Pages/Components/TableToolbar';
import TableToolbarSubtitle from '../../../Admin/Pages/Components/TableToolbarSubtitle';

function FixturesSettings(props: PageComponentProps): JSX.Element {
  const { selectedCustomer, selectedSite } = props;
  const {
    headers,
    toggleActionsFixture,
    setToggleActionsFixture,
    toggleViewFixture,
    setToggleViewFixture,
  } = useFixturesPageState();

  const tooltipOffset = 0;
  const isNonReadOnly = Utils.isNonReadOnly();

  const [actions, setActions] = useState('');

  const { data: fixturesResp, mutate: updateFixtures } = useSWR<Array<FixtureObject> | undefined>(
    [`/organizations/${selectedCustomer.id}/fixtures/types`, 'FixturesSettings'],
    (url) => getRequest(url, {}, (data: Array<FixtureObject>): Array<FixtureObject> => data?.map((fixture) => {
      function isProfileMissing() : boolean {
        return (
          typeof fixture.power0 === 'undefined'
          || typeof fixture.power10 === 'undefined'
          || typeof fixture.power20 === 'undefined'
          || typeof fixture.power30 === 'undefined'
          || typeof fixture.power40 === 'undefined'
          || typeof fixture.power50 === 'undefined'
          || typeof fixture.power60 === 'undefined'
          || typeof fixture.power70 === 'undefined'
          || typeof fixture.power80 === 'undefined'
          || typeof fixture.power90 === 'undefined'
          || typeof fixture.power100 === 'undefined'
        );
      }
      const baseObj = { namewarning: (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          className="fixture-name"
          onClick={() => {
            setToggleViewFixture(true);
            setFixtureDetails(fixture);
          }}
        >
          <div className="fixture-name-text">{fixture.name}</div>
          {(isProfileMissing()) && (
            <Tooltip text="Power draw profile missing" offset={tooltipOffset} addStyle={{ marginLeft: '10px' }}>
              <WarningIcon
                className="missingProfileIcon"
              />
            </Tooltip>
          )}
        </div>
      ),
      namewarningTableFilter: fixture.name,
      namewarningTableSort: fixture.name,
      description: fixture.description || '--',
      type: fixture.type || '--',
      powerDraw: fixture.powerDraw || 0,
      manufacturer: fixture.manufacturer || '--',
      manufacturerSku: fixture.manufacturerSku || '--',
      alertMode: fixture.alertMode || 1 };
      const editColumn = isNonReadOnly ? {
        edit: (
          <div className="fixture-edit">
            <EditIcon
              onClick={() => {
                setToggleActionsFixture(true);
                setFixtureDetails(fixture);
                setActions('Edit');
              }}
            />
          </div>
        ) } : {};

      return ({
        ...fixture,
        ...baseObj,
        ...editColumn,
      });
    })),
  );
  const [fixtureDetails, setFixtureDetails] = useState<FixtureObject>({} as FixtureObject);
  const [filteredTableData, setFilteredTableData] = useState([]);

  const downloadFixtures = () => {
    Utils.downloadCSV([{ key: 'name', val: 'Name' }, ...headers].filter((header) => !['rowSelectCheckbox', 'edit', 'namewarning'].includes(header.key)), filteredTableData || [], 'fixtures');
  };

  // usePerformanceMark(isLoading ? Stage.Usable : Stage.Complete, 'Fixtures');

  return (
    <div className="config__content fixtures">
      <AdminSidebar selectedSite={selectedSite} title="Site config">
        <AdminSidebarConfigItems path={window.location.pathname} />
      </AdminSidebar>
      <div className="page-content page-content--medium-margin page-content--large-bottom-margin">
        <TableToolbar
          title="Fixtures"
          subtitle={<TableToolbarSubtitle listLength={fixturesResp?.length || 0} download={() => downloadFixtures()} />}
          addClass="btn-container"
        >
          <>
            {isNonReadOnly && (
              <div className="tabletoolbar__children">
                <Button
                  onClick={() => {
                    setToggleActionsFixture(true);
                    setActions('Create');
                  }}
                  label="Create new"
                  buttonType="primary"
                />
              </div>
            )}
          </>
        </TableToolbar>
        <div className="table table--light top-border-light auto-height">
          <Table
            headers={headers}
            data={fixturesResp}
            setFilteredTableData={setFilteredTableData}
            skipCellMeasure
            colWidthCalcFn={(col: number, width: number): number => {
              const margin = 5;
              const remainCol = 4;
              const { PowerDraw, manufacturersku, edit } = { PowerDraw: 200, manufacturersku: 150, edit: 120 };
              const colWidth = (width - PowerDraw - manufacturersku - edit - margin) / remainCol;
              return [colWidth, colWidth, colWidth, PowerDraw, colWidth, manufacturersku, edit][col];
            }}
            autoheight
          />
        </div>
      </div>
      {toggleActionsFixture && (
      <CreateEditFixture
        modalOpen={setToggleActionsFixture}
        selectedCustomer={selectedCustomer}
        selectedSite={selectedSite}
        updateFixtures={updateFixtures}
        actions={actions}
        fixtureDetails={(actions === 'Edit') ? fixtureDetails : undefined}
      />
      )}
      {toggleViewFixture && (
      <ViewFixture
        modalOpen={setToggleViewFixture}
        fixtureDetails={fixtureDetails}
      />
      )}
    </div>
  );
}

export default FixturesSettings;
